import React from "react";
import PropTypes from "prop-types";

var PosterContainer = function PosterContainer(_ref) {
  var children = _ref.children,
      onClick = _ref.onClick,
      videoState = _ref.videoState,
      scale = _ref.scale,
      frameSource = _ref.frameSource,
      poster = _ref.poster;
  var containerStyle = {
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 2
  };
  var containerInnerStyle = {
    position: "relative"
  };

  if (videoState && videoState.readyState !== 0) {
    containerStyle.width = containerInnerStyle.width = videoState.videoWidth * scale;
    containerStyle.height = containerInnerStyle.height = videoState.videoHeight * scale;
  }

  return React.createElement("div", {
    className: "video-poster-container",
    onClick: onClick,
    style: containerStyle
  }, React.createElement("div", {
    style: containerInnerStyle
  }, React.createElement("div", null, frameSource && React.createElement("div", {
    className: "custom-video-frame",
    style: {
      backgroundImage: "url(" + frameSource + ")"
    }
  }), children, !(videoState || {}).hasStarted && poster && React.createElement("div", {
    className: "video-player-poster",
    style: {
      backgroundImage: "url(" + poster + ")"
    }
  }))));
};

PosterContainer.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.any,
  onClick: PropTypes.func,
  videoState: PropTypes.object,
  scale: PropTypes.number,
  titleBar: PropTypes.shape({
    leftText: PropTypes.string,
    rightText: PropTypes.string
  }),
  frameSource: PropTypes.string,
  poster: PropTypes.string
} : {};
export default PosterContainer;